import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class OutOfBoundsFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return [
            FootballState.OutOfBounds,
            FootballState.PuntOutOfBounds,
            FootballState.FieldGoalOutOfBounds
        ].some((s) => s === fragment.associatedState);
    }

    getRawFragment() {
        const rawPlay = "OB:";
        return rawPlay;
    }
}
